import axios from "axios";
import { getFileHeaders } from "../utils/helper";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";


export const poshComplaintCreateApi =async(data)=>{
    const callResponse = await axios({
      url: endpoints.poshCreate,
      method: 'post',
      headers: getHeaders(),
      data,
    })
      .then((response) => response.data)
      .catch((err) => ({ status: 0, response: err.response, code: err.response.status }))
  
    return callResponse        
  }

  export const fetchposhComplaintApi =async(params)=>{
    return await axios({
        url: endpoints.poshFetch,
        method: "GET",
        headers: getHeaders(),
        params,
      })
        .then(response => response.data)
        .catch(err => ({status:0,response:err.response,code:err.response.status}));          
}

export const poshComplaintFetchByIdApi = async (params) => {
    const callResponse = await axios({
      url: endpoints.poshFetchById,
      method: "GET",
      headers: getHeaders(),
      params,
    })
      .then((response) => response.data)
      .catch((err) => ({status:0,response:err.response,code:err.response.status}))
  
    return callResponse
  }